module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Iron-c7f0e44df69295993c33e2da98f4cdd6.svg";